<div class="tab-content-header">
  <div class="header-left">
    <h1 class="title" *ngIf="title">{{title}}</h1>
    <p class="subtitle" *ngIf="subtitle">{{subtitle}}</p>
  </div>
  <div class="header-right">
    <div class="wrapper-form-control pb-0">
      <input
        class="form-control form-control-search suffix"
        type="search"
        [formControl]="search"
        (keyup.enter)="initSearch()"
        (keyup.esc)="clearSearch()"
        [placeholder]="placeholder">
      <i class="far fa-search icon-suffix pointer" (click)="initSearch()"></i>
    </div>
  </div>
</div>
